import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';

import { AnalyticsService } from 'app/analytics/analytics.service';
import { TemplatesService } from 'app/apps/templates.service';
import { RouteParamsService } from 'app/shared/service/route-params.service';

@Component({
  selector: 'cc-team-dashboards-list',
  templateUrl: './dashboards-list.component.html',
  styleUrls: ['./dashboards-list.component.scss'],
})
export class TeamDashboardsListComponent implements OnInit, OnDestroy {
  unSubscribe = new Subject<void>();
  teamId;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly analyticsService: AnalyticsService,
    private readonly templatesService: TemplatesService,
    private readonly routeParamsService: RouteParamsService,
  ) {}

  ngOnInit() {
    this.router.events
      .pipe(
        takeUntil(this.unSubscribe),
        filter((event) => event instanceof NavigationEnd),
        filter(() => {
          const { state } = this.router.getCurrentNavigation().extras;
          return state && state.reload;
        }),
      )
      .subscribe(() => {
        this.loadDashboards();
        this.loadTemplates();
      });

    this.teamId = this.route.snapshot.paramMap.get('teamId');
    this.loadDashboards();
    this.loadTemplates();
  }

  private loadDashboards(): void {
    this.routeParamsService.set('dashboards', this.analyticsService.getTeamDashboards(this.teamId) as any);
  }

  private loadTemplates(): void {
    this.routeParamsService.set('templates', this.templatesService.getTemplatesByTeam(this.teamId) as any);
  }

  ngOnDestroy(): void {
    this.routeParamsService.set('dashboards', null);
    this.routeParamsService.set('templates', null);
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }
}
